const doc = [({"ko":({"buttonBookingCamp":({"cancelBookingPlan":"이 플랜의 예약 취소", "cancelBookingRoom":"이 구획의 예약을 취소"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;